import AttachmentConverter from "../../../../../../lib/attachment/AttachmentConverter";

export function attachmentSetContent(editor, content) {
  return AttachmentConverter.convertToHtml(content)
}

export function attachmentPreProcess(editor, e) {
  AttachmentConverter.convertToTistory(editor, e)
}
